import React from "react";

const summary = <p>A ‘proof of concept’ video for my proposed feature-length documentary on the essential harmony between science and religion. It endeavours to use interviews, images, and narration to show how religion and science are complimentary paths to a single truth.  2017</p>;

export default summary;